import React from "react";
import styles from "./Filters.module.scss";
import { LIFESTAGE_MAPPINGS } from "./FilterMappings";
export default function LifeStage(props) {

    const {currentLifeStage, setCurrentLifeStage} = props;
    const stage = LIFESTAGE_MAPPINGS;

    const selectLifeStage = (key) => {
        if (currentLifeStage === key) {
            return setCurrentLifeStage(0)
        }

        setCurrentLifeStage(key)
    }

    return (
        <>
            <div className={styles.formSection}>
                <h3>Life Stage</h3>
                <div className={styles.verticaloffsetmedium }>Adding a life stage filter may help you narrow down options of financial advisors well-versed in the specific challenges, opportunities, and decisions you're likely facing based on the stage of life you're in.</div>
                    <div className={styles.industryTypesContainer}>
                    {stage.map((item) => {
                        return <div className={currentLifeStage === item.key ?  styles.industryTypeSelected : styles.industryType} key={item.key} onClick={() => selectLifeStage(item.key)}>{item.text}</div>
                    })}
                </div>
            </div>
        </>
    )
}